import { ErrorMessage } from '@hookform/error-message';
import { Checkbox, FormControlLabel, FormLabel } from '@material-ui/core';
import React, { memo, useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import './CheckboxRhf.css';
const CheckboxRhf = ({
    label,
    name,
    defaultValue,
    disable,
    question,
    checkBoxValue,
    showSingleError = true,
    readOnly = false,
    onChange,
}) => {
    const {
        formState: { errors },
        register,
        control,
        setValue,
    } = useFormContext();
    useEffect(() => {
        setValue(name, defaultValue);
    }, []);
    return (
        <div id={name}>
            <FormLabel component="legend">{question}</FormLabel>
            {
                // label ?
                //   <FormControlLabel control={
                //     <input type="checkbox" className="myCheckbox" disabled={disable}  {...register(name)} value={checkBoxValue} defaultValue={defaultValue} />
                //   }
                //     label={label}
                //   /> :
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                        type="checkbox"
                        className="myCheckbox"
                        disabled={disable || readOnly}
                        {...register(name)}
                        onChange={onChange}
                        value={checkBoxValue}
                    />
                    {label !== '' && <div style={{ marginLeft: 8 }}>{label}</div>}
                </div>
            }
            {showSingleError && (
                <div style={{ marginLeft: 8 }}>
                    <ErrorMessage
                        errors={errors}
                        name={name}
                        render={({ message }) => <div style={{ color: 'red' }}>{message}</div>}
                    />
                </div>
            )}
        </div>

        // <div id={name}>
        //   <FormLabel component="legend" >{question}</FormLabel>
        //   <FormControlLabel control={
        //     <Controller
        //       control={control}
        //       name={name}
        //       render={({ field: { onChange, onBlur, value, name, ref } }) => (
        //         <Checkbox
        //           disabled={disable}
        //           onChange={onChange}
        //           name={name}
        //           checked={value}
        //           defaultValue={defaultValue}
        //           inputProps={{ 'aria-label': label }}
        //         />
        //       )}
        //       defaultValue={defaultValue}
        //     />
        //   }
        //     label={label}
        //   />
        //   <div style={{color:'red'}}>
        //         {errors?.[name.replace(/\.\d+$/, '')] && 'Required'}
        //   </div>
        //   {/* <div style={{color:'red'}}>
        //         {errors?.[name.replace(/\.\d+$/, '')]?.root?.message}
        //   </div> */}

        // </div>
    );
};

export default memo(CheckboxRhf);
